import { render, staticRenderFns } from "./TableCreationPart.vue?vue&type=template&id=051dbe5a&scoped=true&"
import script from "./TableCreationPart.vue?vue&type=script&lang=js&"
export * from "./TableCreationPart.vue?vue&type=script&lang=js&"
import style0 from "./TableCreationPart.vue?vue&type=style&index=0&id=051dbe5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051dbe5a",
  null
  
)

export default component.exports